<template>
    <div>

        <div class="field">
            <label class="label">Filter by Name</label>
            <div class="control">
                <input class="input" type="text" v-model="search" placeholder="Search forename or surname">
            </div>
        </div>

        <div v-if="loading == false" class="hours-worked-table-container">
            <table class="table is-bordered is-striped is-narrow">
                <thead>
                    <tr>
                        <th class="member-column">Member</th>
                        <th>Employment Type</th>
                        
                        <th>Total Weeks</th>
                        <th>Weekly Average</th>
                        <th v-for="date in dates" :key="date">{{ date }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="member in members" :key="member.member_id" :class="{ 'has-text-weight-bold': member.employmentType === 'Full Time' }">
                        <td class="member-column">{{ member.forename }} {{ member.surname }}</td>
                        <td>{{ member.employmentType }}</td>
                        
                        <td>{{ member.weekCount }}</td>
                        <td>{{ member.averageHoursPerWeek }}</td>
                        <td v-for="date in dates" :key="date">{{ member.hoursByDate[date] }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>
</template>

<script>
import UtilityService from '@/services/UtilityService.js';
//import BookingService from '@/services/BookingService.js';
import MemberMixin from '@/mixins/MemberMixin.js';

export default {
    
      name: 'HoursWorked',
        mixins: [MemberMixin],
        data: function () {
            return {
                   search: '',
                   hours_worked: [],
                   loading: true,
                   alertText: '',
                   accessToken: '',
                   working: false,
                   fullTimeHoursThreshold: 30
                   
            }
        },
        computed: {
            dates() {
                const dates = [...new Set(this.hours_worked.map(row => row.date))];
                return dates.sort();
            },
            members() {
                const membersByMemberId = {};
                this.hours_worked.forEach(row => {
                    if (!membersByMemberId[row.member_id]) {
                        membersByMemberId[row.member_id] = {
                            member_id: row.member_id,
                            forename: row.forename,
                            surname: row.surname,
                            hoursByDate: {},
                            weeksWithHours: new Set()
                        };
                    }
                    const member = membersByMemberId[row.member_id];
                    member.hoursByDate[row.date] = row.hours;
                    if (row.hours > 0) {
                        member.weeksWithHours.add(this.getWeekKey(row.date));
                    }
                });

                Object.values(membersByMemberId).forEach(member => {
                    const totalHours = Object.values(member.hoursByDate).reduce((sum, hours) => sum + hours, 0);
                    const weekCount = member.weeksWithHours.size;
                    const averageHoursPerWeek = weekCount > 0 ? totalHours / weekCount : 0;
                    member.totalHours = totalHours;
                    member.weekCount = weekCount;
                    member.averageHoursPerWeek = averageHoursPerWeek.toFixed(2);
                    member.employmentType = averageHoursPerWeek >= this.fullTimeHoursThreshold ? 'Full Time' : 'Part Time';
                });

                const sorted = Object.values(membersByMemberId).sort((a, b) => {
                    return (a.surname + a.forename).localeCompare(b.surname + b.forename);
                });

                const search = this.search.trim().toLowerCase();
                if (!search) {
                    return sorted;
                }

                return sorted.filter(member => {
                    return member.forename.toLowerCase().includes(search)
                        || member.surname.toLowerCase().includes(search);
                });
            }
        },
        methods: {
            getWeekKey(dateString) {
                // parse and compute entirely in UTC to avoid local timezone shifting the date
                const [year, month, day] = dateString.split('-').map(Number);
                const date = new Date(Date.UTC(year, month - 1, day));
                // shift back to the Monday of that week and use it as the key
                date.setUTCDate(date.getUTCDate() - ((date.getUTCDay() + 6) % 7));
                const mondayYear = date.getUTCFullYear();
                const mondayMonth = String(date.getUTCMonth() + 1).padStart(2, '0');
                const mondayDay = String(date.getUTCDate()).padStart(2, '0');
                return `${mondayYear}-${mondayMonth}-${mondayDay}`;
            },
            async getHoursWorked() {
                this.loading=true
                UtilityService.getSimpleApiData(this.accessToken, "hours_worked")
                .then(
                    (hours_worked => {
                        this.$set(this, "hours_worked", hours_worked);
                        this.loading=false
                    }).bind(this)
                );
            },
            
            
        },
        created() {
            this.getAccessToken()
            .then(() => { 
                this.getHoursWorked();
                
            });
        
        },
    }
</script>

<style scoped>
.hours-worked-table-container {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

.hours-worked-table-container table {
    white-space: nowrap;
}

.member-column {
    position: sticky;
    left: 0;
    background-color: #fff;
    z-index: 1;
}
</style>